import type { SVGProps } from 'react';

export const Trophy = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 2.12118L15.8788 0L8.12136 0L6.00004 2.12132L6 6C6 13.4998 10.5 15 10.5 15V18H7.5V21H4.5V24H19.5V21H16.5V18H13.5V15C13.5 15 18 13.4998 18 6V2.12118Z"
        fill="currentColor"
      />
      <path
        d="M3 3H0L0 4.5C0 5.89397 0 6.59095 0.115288 7.17054C0.579053 9.50204 2.37385 11.335 4.68419 11.854C3.73177 10.5066 3 8.61917 3 6V3Z"
        fill="currentColor"
      />
      <path
        d="M19.3158 11.8539C21.6262 11.335 23.4209 9.50204 23.8847 7.17054C24 6.59095 24 5.89397 24 4.5V3H21V6C21 8.61916 20.2682 10.5066 19.3158 11.8539Z"
        fill="currentColor"
      />
    </svg>
  );
};
